import styles from "./styles.module.scss";

export const SummerCampRegistration = () => {
  return (
    <div className={styles.trainAwsPdApplication}>
      <div className="container">
        <div className={styles.iframeContainer}>
          <iframe
            id="JotFormIFrame-240494463764161"
            title="The Coding School's Summer 2024 Camp Registration Form"
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            allowfullscreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/240494463764161"
          >
          </iframe>
        </div>
      </div>
    </div>
  );
};
